import Bacon from './Bacon';

export default Bacon;
